var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-px"},[_c('button',{staticClass:"btn btn-tertiary h-full",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('ArrowLeft',{staticClass:"btn-icon-left"}),_vm._v("\n    Back\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }